export enum ArrayOrder {
  'asc' = -1,
  'desc' = 1,
}

export function sortProps<T>(
  list: Array<T>,
  props: Array<keyof T>,
  order: ArrayOrder = ArrayOrder.asc,
): Array<T> {
  return list.sort((a, b) =>
    props.every((p) => a[p] == b[p]) ? 0
    : props.every((p) => a[p] > b[p]) ? -1 * order
    : 1 * order,
  );
}
